import { useConfig } from '../config';

export function calculateVatMultiplier(vatRate: number, priceWithVat: boolean): number {
	return priceWithVat ? 1.0 + vatRate / 10000 : 1.0;
}

export function useDefaultVatMultiplier(priceWithVat: boolean): number {
	const { defaultVat } = useConfig();
	return priceWithVat ? 1.0 + defaultVat / 100 : 1.0;
}
